import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';

import { PATH } from '../../constants';
import ErrorBoundary from '../../submodules/shared/components/error-boundary/error-boundary';

import LabCerts from './lab-certs';
import LabEdit from './lab-edit';
import LabInstructions from './lab-instructions';
import LabStart from './lab-start';
import LabView from './lab-view';

class Lab extends React.Component {
    constructor(props) {
        super(props);

        const {
            match: {
                params: { id, action },
            },
            fetchLabDetails,
            clearLabDetails,
            fetchLabInstructions,
        } = this.props;

        if (id) {
            fetchLabDetails(id);
            if (action === 'instructions') {
                fetchLabInstructions(id);
            }
        } else {
            clearLabDetails();
        }
    }
    render() {
        const {
            match: {
                params: { action, id },
            },
        } = this.props;
        const boundaryKey = `${id || 'new'}:${action || 'edit'}`;
        let name;
        let view;

        switch (action) {
            case PATH.lab_actions.VIEW:
                name = 'lab:view';
                view = <LabView {...R.pick(['appReducer', 'labReducer', 'match', 'deleteLab'], this.props)} />;
                break;
            case PATH.lab_actions.INSTRUCTIONS:
                name = 'lab:instructions';
                view = <LabInstructions {...R.pick(['labReducer'], this.props)} />;
                break;
            case PATH.lab_actions.LABSTART:
                name = 'lab:start';
                view = <LabStart {...R.pick(['labReducer', 'eventReducer'], this.props)} />;
                break;
            case PATH.lab_actions.CERTS:
                name = 'lab:certs';
                view = <LabCerts {...R.pick(['labReducer', 'uploadLabKeys'], this.props)} />;
                break;

            default:
                name = 'lab:editor';
                view = (
                    <LabEdit
                        {...R.pick(
                            ['upsertLab', 'fetchProducts', 'labReducer', 'match', 'clearLabDetails'],
                            this.props,
                        )}
                    />
                );
        }
        return (
            <div className="lab">
                <ErrorBoundary key={boundaryKey} name={name}>
                    {view}
                </ErrorBoundary>
            </div>
        );
    }
}

Lab.propTypes = {
    match: PropTypes.object,
    fetchLabDetails: PropTypes.func,
    clearLabDetails: PropTypes.func,
    fetchLabInstructions: PropTypes.func,
    uploadLabKeys: PropTypes.func,
};

export default Lab;
